import {
  arrayOf, bool, params, shape, string
} from '@thd-nucleus/data-sources';

export const dataModel = {
  product: params({ itemId: string().isRequired() }).shape({
    itemId: string(),
    dataSource: string(),
    identifiers: shape({
      isSuperSku: bool(),
      parentId: string()
    }),
    specificationGroup: arrayOf(shape({
      specTitle: string(),
      specifications: arrayOf(shape({
        specName: string(),
        specValue: string()
      }))
    }))
  }),
  metadata: params({ parentId: string().isRequired() }).shape({
    attributes: arrayOf(shape({
      attributeValues: arrayOf(shape({
        value: string()
      })),
      attributeName: string()
    })),
    superDuperSku: shape({
      attributes: arrayOf(shape({
        attributeName: string(),
        attributeValues: arrayOf(shape({
          selected: bool(),
          value: string()
        }))
      }))
    })
  })
};
